import { del, get, post } from '../apiRequest';
import { ServerActionName } from './action-names';
import { ClaimRow } from './claims';

export interface Option {
  id: number;
  name: string;
}

export interface StructureHeaderOption {
  id: number;
  name: string;
  headerOptionId: number;
}

export interface StructureFooterOption {
  id: number;
  name: string;
  footerOptionId: number;
}

export interface Claim {
  id: number;
  exporterId: number;
  claimId: number;
  claimReferenceNumber: string;
  counterPartyName: string;
  proposedDebtor: string;
  currentTotal: number;
}

export interface ClaimGlobalFootnote {
  id: number;
  footnote: string;
  footnoteAppearOptionId: number;
}

export interface ClaimReferencingFootnote {
  id: number;
  claimReferenceNumber: string;
  footnote: string;
  footnoteAppearOptionId: number;
}

export interface ExhibitHistory {
  id: number;
  exhibitNumber: string;
  objectionBasis: string;
  actionNameId: number;
  exportDocument: string;
  actionName: ServerActionName;
  claims: Claim[];
  structureHeaders: StructureHeaderOption[];
  structureFooters: StructureFooterOption[];
  globalFootnotes: ClaimGlobalFootnote[];
  referencingClaimFootnotes: ClaimReferencingFootnote[];
  createdBy: string;
  createdDate: string;
}

export interface ExhibitPost {
  exhibitNumber: string;
  objectionBasis: string;
  actionNameId: number;
  claims: number[];
  structureHeaderOptions: number[];
  structureFooterOptions: number[];
  globalFootnotes: {
    footnote: string;
    footnoteAppearOptionId: number;
  }[];
  referencingClaimFootnotes: any[];
}

export const exhibits = {
  get: (id: number) =>
    get<ExhibitHistory>(`v1/ExhibitExporter/getExhibitExporter/${id}`),
  delete: (id: number) => del(`v1/ExhibitExporter/deleteExhibitExporter/${id}`),
  create: (exhibitData: ExhibitPost) =>
    post('v1/ExhibitExporter/createExhibitExporter', exhibitData),

  getAll: () => get<ExhibitHistory[]>('v1/ExhibitExporter/getAllExhibitExporters'),
  getChildClaims: (id: number) =>
    get<ClaimRow[]>(`v1/ExhibitExporter/getChildClaims/${id}`),

  // *** redundant APIs ********
  // getHeaderOptions: (): Promise<Option[] | undefined> =>
  //   get<Option[]>('v1/ExhibitExporter/getExhibitExporterHeaderOptions'),
  // getFooterOptions: (): Promise<Option[] | undefined> =>
  //   get<Option[]>('v1/ExhibitExporter/getExhibitExporterFooterOptions'),
  // getFootnoteAppearOptions: (): Promise<Option[] | undefined> =>
  //   get<Option[]>('v1/ExhibitExporter/getExhibitExporterFootnoteAppearOptions'),
};
